import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import {
  BlockchainIcon,
  CodeIcon,
  MapDoubleIcon,
  RelativityIcon,
  Setting1Icon,
  SwapIcon,
} from 'tdesign-icons-react';
import SvgIcon from '@/components/SvgIcon';
import { isVoid } from '@/utils/common';
import { getIsOrdinaryUserPrompt } from '@/services/authService';
import { messageTypes } from '@/utils/constant';

// redux中不直接使用React Node，做个基础转换
// td:开头为Tdesign icon
export const getMenuIcon = (txt) => {
  if (isVoid(txt)) return null;
  if (txt.indexOf('td:') > -1) {
    const icon = txt.slice(3);
    switch (icon) {
      case 'CodeIcon':
        return <CodeIcon />;
      case 'SwapIcon':
        return <SwapIcon />;
      case 'BlockchainIcon':
        return <BlockchainIcon />;
      case 'RelativityIcon':
        return <RelativityIcon />;
      case 'MapDoubleIcon':
        return <MapDoubleIcon />;
      case 'Setting1Icon':
        return <Setting1Icon />;
      default:
        return;
    }
  }
  return <SvgIcon type={txt} />;
};

const menus = [
  {
    label: '集群管理',
    id: 'cluster',
    path: '/cluster',
    resource: 'pulsar:cluster',
    children: [
      {
        label: 'Cluster',
        id: 'cluster/dashboard',
        path: '/cluster/dashboard',
        resource: 'pulsar:cluste',
        icon: 'pulsar',
      },
      {
        label: 'Broker',
        id: 'cluster/broker',
        icon: 'broker',
        resource: 'pulsar:broker',
        eventId: 'BROKER_DETAIL_ACCORDION',
        children: [
          {
            label: 'Overview',
            id: 'cluster/broker/dashboard',
            path: '/cluster/broker/dashboard',
            resource: 'pulsar:broker:overview',
            eventId: 'BROKER_DETAIL_OVERVIEW',
          },
          {
            label: 'Broker 列表',
            id: 'cluster/broker/list',
            path: '/cluster/broker/list',
            resource: 'pulsar:broker:list',
            eventId: 'BROKER_DETAIL_BROKER_LIST',
          },
        ],
      },
      {
        label: 'Bookkeeper',
        id: 'cluster/bookkeeper',
        icon: 'bookkeeper',
        resource: 'pulsar:bookkeeper',
        eventId: 'BOOKKEEPER_DETAIL_ACCORDION',
        children: [
          {
            label: 'Overview',
            eventId: 'BOOKKEEPER_DETAIL_OVERVIEW',
            id: 'cluster/bookkeeper/dashboard',
            path: '/cluster/bookkeeper/dashboard',
            resource: 'pulsar:bookkeeper:overview',
          },
          {
            label: 'Bookie 列表',
            eventId: 'BOOKKEEPER_DETAIL_BOOKIE_LIST',
            id: 'cluster/bookkeeper/list',
            path: '/cluster/bookie/list',
            resource: 'pulsar:bookkeeper:list',
          },
          {
            label: 'AutoRecover',
            eventId: 'BOOKKEEPER_DETAIL_AUTORECOVER_LIST',
            id: 'cluster/bookkeeper/auto-recover',
            path: '/cluster/bookkeeper/auto-recover',
            resource: 'pulsar:bookkeeper:autoRecover',
          },
        ],
      },
      {
        label: 'Zookeeper',
        eventId: 'ZOOKEEPER_DETAIL_ACCORDION',
        id: 'cluster/zookeeper',
        icon: 'zookeeper',
        resource: 'pulsar:zookeeper',
        children: [
          {
            label: 'Overview',
            eventId: 'ZOOKEEPER_DETAIL_OVERVIEW',
            id: 'cluster/zookeeper/dashboard',
            path: '/cluster/zookeeper/dashboard',
            resource: 'pulsar:zookeeper:overview',
          },
          {
            label: 'Server 列表',
            eventId: 'ZOOKEEPER_DETAIL_SERVER_LIST',
            id: 'cluster/zookeeper/list',
            path: '/cluster/zookeeper/list',
            resource: 'pulsar:zookeeper:serverList',
          },
        ],
      },
      {
        label: '租户',
        id: 'cluster/tenant',
        eventId: 'TENANT_DETAIL_ACCORDION',
        icon: 'tenant',
        resource: 'pulsar:tenant',
        children: [
          {
            label: '租户列表',
            eventId: 'TENANT_DETAIL_TENANT_LIST',
            id: 'cluster/tenant/list',
            resource: 'pulsar:tenant:list',
            path: '/cluster/tenant/list',
          },
        ],
      },
      {
        label: '命名空间',
        id: 'cluster/namespace',
        icon: 'namespace',
        eventId: 'NAMESPACE_DETAIL_ACCORDION',
        resource: 'pulsar:namespace',
        children: [
          {
            label: '命名空间',
            eventId: 'NAMESPACE_DETAIL_NAMESPACE_LIST',
            id: 'cluster/namespace/list',
            path: '/cluster/namespace/list',
            resource: 'pulsar:namespace:list',
          },
        ],
      },
      {
        label: 'Topic',
        id: 'cluster/topic',
        icon: 'topic',
        resource: 'pulsar:topic',
        eventId: 'TOPIC_DETAIL_ACCORDION',
        children: [
          {
            label: 'Topic列表',
            eventId: 'TOPIC_DETAIL_TOPIC_LIST',
            id: 'cluster/topic/list',
            resource: 'pulsar:topic:list',
            path: '/cluster/topic/list',
          },
        ],
      },
      {
        label: 'Function',
        id: 'cluster/function',
        icon: 'fx',
        resource: 'pulsar:function',
        eventId: 'FUNCTION_DETAIL_ACCORDION',
        children: [
          {
            label: '包管理',
            id: 'cluster/ackageManage',
            eventId: 'FUNCTION_DETAIL_PACKAGEMANAGE_LIST',
            resource: 'pulsar:function:packageManage',
            path: '/cluster/function-packageManage/list',
          },
          {
            label: 'Function列表',
            id: 'cluster/function',
            eventId: 'FUNCTION_DETAIL_FUNCTION_LIST',
            resource: 'pulsar:function:function',
            path: '/cluster/function/list',
          },
          {
            label: 'Source列表',
            id: 'cluster/source',
            eventId: 'FUNCTION_DETAIL_SOURCE_LIST',
            resource: 'pulsar:function:source',
            path: '/cluster/function-source/list',
          },
          {
            label: 'Sink列表',
            id: 'cluster/sink',
            eventId: 'FUNCTION_DETAIL_SINK_LIST',
            resource: 'pulsar:function:sink',
            path: '/cluster/function-sink/list',
          },
        ],
      },
      {
        label: '权限',
        id: 'cluster/permissions',
        icon: 'permissions',
        resource: 'pulsar:auth',
        eventId: 'PERMISSION_DETAIL_ACCORDION',
        children: [
          {
            label: '角色',
            id: 'cluster/permissions/roles',
            eventId: 'PERMISSION_DETAIL_ROLE_LIST',
            path: '/cluster/permissions/roles',
            resource: 'pulsar:auth:role',
          },
          {
            label: '授权',
            id: 'cluster/permissions/grant',
            eventId: 'PERMISSION_DETAIL_GRANT_LIST',
            path: '/cluster/permissions/grant',
            resource: 'pulsar:auth:auth',
          },
        ],
      },
      {
        label: '工具',
        id: 'cluster/utils',
        eventId: 'UTIL_DETAIL_ACCORDION',
        icon: 'tool',
        resource: 'pulsar:tool',
        children: [
          {
            label: 'Message 相关',
            id: 'cluster/utils/message',
            eventId: 'UTIL_DETAIL_MESSAGE_LIST',
            path: '/cluster/utils/message',
            resource: 'pulsar:tool:message',
          },
          {
            label: 'Token 验证',
            id: 'cluster/utils/token',
            path: '/cluster/utils/token',
            eventId: 'UTIL_DETAIL_TOKEN_LIST',
            resource: 'pulsar:tool:token',
          },
        ],
      },
    ],
  },
  {
    label: '集群管理',
    id: 'kop-cluster',
    path: '/kop-cluster',
    resource: 'kop:cluster',
    children: [
      {
        label: 'Cluster',
        id: 'kop-cluster/dashboard',
        path: '/kop-cluster/dashboard',
        resource: 'kop:cluste',
        icon: 'kop',
      },
      {
        label: 'Broker',
        id: 'kop-cluster/broker',
        icon: 'broker',
        resource: 'kop:broker',
        children: [
          {
            label: 'Overview',
            id: 'kop-cluster/broker/dashboard',
            path: '/kop-cluster/broker/dashboard',
            resource: 'kop:broker:overview',
          },
          {
            label: 'Broker 列表',
            id: 'kop-cluster/broker/list',
            path: '/kop-cluster/broker/list',
            resource: 'kop:broker:list',
          },
        ],
      },
      {
        label: 'Bookkeeper',
        id: 'kop-cluster/bookkeeper',
        icon: 'bookkeeper',
        resource: 'kop:bookkeeper',
        children: [
          {
            label: 'Overview',
            id: 'kop-cluster/bookkeeper/dashboard',
            path: '/kop-cluster/bookkeeper/dashboard',
            resource: 'kop:bookkeeper:overview',
          },
          {
            label: 'Bookie 列表',
            id: 'kop-cluster/bookkeeper/list',
            path: '/kop-cluster/bookie/list',
            resource: 'kop:bookkeeper:list',
          },
          {
            label: 'AutoRecover',
            id: 'kop-cluster/bookkeeper/auto-recover',
            path: '/kop-cluster/bookkeeper/auto-recover',
            resource: 'kop:bookkeeper:autoRecover',
          },
        ],
      },
      {
        label: 'Zookeeper',
        id: 'kop-cluster/zookeeper',
        icon: 'zookeeper',
        resource: 'kop:zookeeper',
        children: [
          {
            label: 'Overview',
            id: 'kop-cluster/zookeeper/dashboard',
            path: '/kop-cluster/zookeeper/dashboard',
            resource: 'kop:zookeeper:overview',
          },
          {
            label: 'Server 列表',
            id: 'kop-cluster/zookeeper/list',
            path: '/kop-cluster/zookeeper/list',
            resource: 'kop:zookeeper:serverList',
          },
        ],
      },
      {
        label: '租户',
        id: 'kop-cluster/tenant',
        icon: 'tenant',
        resource: 'kop:tenant',
        children: [
          {
            label: '租户列表',
            id: 'kop-cluster/tenant/list',
            resource: 'kop:tenant:list',
            path: '/kop-cluster/tenant/list',
          },
        ],
      },
      {
        label: '命名空间',
        id: 'kop-cluster/namespace',
        icon: 'namespace',
        resource: 'kop:namespace',
        children: [
          {
            label: '命名空间',
            id: 'kop-cluster/namespace/list',
            resource: 'kop:namespace:list',
            path: '/kop-cluster/namespace/list',
          },
        ],
      },
      {
        label: 'Topic',
        id: 'kop-cluster/topic',
        icon: 'topic',
        resource: 'kop:topic',
        // eventId: 'KOP_TOPIC_DETAIL_ACCORDION',
        children: [
          {
            label: 'Topic列表',
            // eventId: 'KOP_TOPIC_DETAIL_TOPIC_LIST',
            id: 'kop-cluster/topic/list',
            resource: 'kop:topic:list',
            path: '/kop-cluster/topic/list',
          },
        ],
      },
      {
        label: 'Consumer',
        id: 'kop-cluster/consumer-group',
        icon: 'td:BlockchainIcon',
        resource: 'kop:consumer-group',
        children: [
          {
            label: 'ConsumerGroup',
            id: 'kop-cluster/consumer-group/list',
            resource: 'kop:consumer-group:list',
            path: '/kop-cluster/consumer-group/list',
          },
        ],
      },
      {
        label: '权限',
        id: 'kop-cluster/permissions',
        icon: 'permissions',
        resource: 'kop:auth',
        children: [
          {
            label: '用户',
            id: 'kop-cluster/permissions/users',
            path: '/kop-cluster/permissions/users',
            resource: 'kop:auth:user',
          },
          {
            label: 'ACLs',
            id: 'kop-cluster/permissions/grant',
            path: '/kop-cluster/permissions/grant',
            resource: 'kop:auth:grant',
          },
        ],
      },
    ],
  },
  {
    label: '运维管理',
    id: 'maintenance',
    path: '/maintenance',
    resource: 'pulsar:maintenance',
    children: [
      {
        label: '资源管理',
        id: 'maintenance/resource',
        icon: 'support',
        eventId: 'RESOURCE_DETAIL_ACCORDIN',
        resource: 'pulsar:resource',
        children: [
          {
            label: '环境信息',
            eventId: 'RESOURCE_DETAIL_ENV_LIST',
            id: 'maintenance/resource/cluster-env',
            path: '/maintenance/resource/env',
            resource: 'pulsar:resource:env',
          },
          {
            label: '集群信息',
            eventId: 'RESOURCE_DETAIL_CLUSTER_LIST',
            id: 'maintenance/resource/cluster',
            path: '/maintenance/resource/cluster',
            resource: 'pulsar:resource:clusters',
          },
          {
            label: '主机信息',
            id: 'maintenance/resource/host',
            eventId: 'RESOURCE_DETAIL_HOST_LIST',
            path: '/maintenance/resource/host',
            resource: 'pulsar:resource:hosts',
          },
          {
            label: 'K8S集群',
            id: 'maintenance/resource/k8s',
            eventId: 'RESOURCE_DETAIL_K8S_LIST',
            path: '/maintenance/resource/k8s',
            resource: 'pulsar:resource:k8sCluster',
          },
        ],
      },
      {
        label: '模板管理',
        id: 'maintenance/template',
        icon: 'template',
        resource: 'pulsar:stencil',
        children: [
          {
            label: '变量管理',
            id: 'maintenance/template/variables',
            path: '/maintenance/template/variables',
            resource: 'pulsar:stencil:variables',
            eventId: 'TEMPLATE_DETAIL_VARIABLE_LIST',
          },
          {
            label: '脚本模板',
            id: 'maintenance/template/script',
            eventId: 'TEMPLATE_DETAIL_SCRIPT_LIST',
            path: '/maintenance/template/script',
            resource: 'pulsar:stencil:script',
          },
          {
            label: '组件模板',
            id: 'maintenance/template/component',
            path: '/maintenance/template/component',
            resource: 'pulsar:stencil:component',
            eventId: 'TEMPLATE_DETAIL_COMPONENT_LIST',
          },
          {
            label: '流程模板',
            id: 'maintenance/template/flow',
            path: '/maintenance/template/flow',
            eventId: 'TEMPLATE_DETAIL_FLOW_LIST',
            resource: 'pulsar:stencil:flow',
          },
        ],
      },
      {
        label: '执行中心',
        id: 'maintenance/executive',
        icon: 'terminal',
        resource: 'pulsar:exec',
        children: [
          {
            label: '脚本执行',
            id: 'maintenance/executive/script',
            path: '/maintenance/executive/script',
            resource: 'pulsar:exec:script',
          },
          {
            label: '组件执行',
            path: '/maintenance/executive/component',
            resource: 'pulsar:exec:component',
            id: 'maintenance/executive/component',
          },
          {
            label: '流程执行',
            path: '/maintenance/executive/flow',
            resource: 'pulsar:exec:flow',
            id: 'maintenance/executive/flow',
          },
          {
            label: '操作记录',
            path: '/maintenance/executive/record',
            resource: 'pulsar:exec:log',
            eventId: 'EXECUTIVE_DETAIL_RECORD_LIST',
            id: 'maintenance/executive/record',
          },
          {
            label: '查看变量',
            path: '/maintenance/executive/variables',
            resource: 'pulsar:exec:variable',
            eventId: 'EXECUTIVE_DETAIL_VARIABLE',
            id: 'maintenance/executive/variables',
          },
        ],
      },
      {
        label: '运维审查',
        icon: 'system-regulation',
        resource: 'pulsar:inspect',
        id: 'maintenance/inspect',
        children: [
          {
            label: '代理检测',
            path: '/maintenance/inspect/proxy-detected',
            resource: 'pulsar:inspect:proxy-detected',
            id: 'maintenance/inspect/proxy-detected',
          },
        ],
      },
      {
        label: '容灾管理',
        icon: 'td:MapDoubleIcon',
        resource: 'pulsar:recovery',
        id: 'maintenance/recovery',
        children: [
          {
            label: '服务发现',
            path: '/maintenance/recovery/service-discovery',
            resource: 'pulsar:recovery:service-discovery',
            id: 'maintenance/recovery/service-discovery',
          },
        ],
      },
    ],
  },

  {
    label: '平台管理',
    path: '/platform',
    resource: 'pulsar:sys',
    id: 'platform',
    children: [
      {
        label: '平台配置',
        path: '/platform/config',
        icon: 'td:Setting1Icon',
        resource: 'pulsar:sys:config',
        id: 'platform/config',
      },
      {
        label: '组管理',
        id: 'platform/organize',
        icon: 'td:RelativityIcon',
        resource: 'platform:organize',
        path: '/platform/organize',
      },
      {
        label: '角色管理',
        path: '/platform/role',
        icon: 'secured-icon',
        resource: 'pulsar:sys:role',
        id: 'platform/role',
      },
      {
        label: '用户管理',
        path: '/platform/user',
        icon: 'user-password-icon',
        resource: 'pulsar:sys:user',
        id: 'platform/user',
      },
      {
        label: '数据字典',
        path: '/platform/dictionary',
        eventId: 'PLATFORM_DATA_DICTIONARY',
        icon: 'book-open',
        resource: 'pulsar:sys:dict',
        id: 'platform/dictionary',
      },
      {
        label: '巡检指标',
        path: '/platform/inspect',
        eventId: 'PLATFORM_INSPECTION_RULES',
        icon: 'inspect',
        resource: 'pulsar:sys:rules',
        id: 'platform/inspect',
      },
      {
        label: '资源管理',
        path: '/platform/menu',
        icon: 'menu-application-icon',
        resource: 'pulsar:sys:menu',
        id: 'platform/menu',
      },
      {
        label: '审计日志',
        path: '/platform/logs',
        icon: 'address-book',
        eventId: 'PLATFORM_AUDIT_LOG',
        resource: 'pulsar:sys:logs',
        id: 'platform/logs',
      },
      {
        label: 'License管理',
        path: '/platform/license',
        icon: 'license',
        resource: 'pulsar:sys:license',
        id: 'platform/license',
      },
    ],
  },
  {
    label: '开发指引',
    path: '/dev',
    resource: 'pulsar:dev',
    id: 'dev',
    children: [
      {
        label: '代码示例',
        path: '/dev/code-samples',
        resource: 'pulsar:dev:codeSamples',
        eventId: 'DEV_CODE_EXAMPLE',
        icon: 'td:CodeIcon',
        id: 'dev/code-samples',
      },
      {
        label: '消息收发',
        path: '/dev/message-send-receive',
        resource: 'pulsar:dev:messageSendReceive',
        eventId: 'MESSAGE_SEND_RECEIVE',
        icon: 'td:SwapIcon',
        id: 'dev/message-send-receive',
      },
    ],
  },
  {
    label: '高级功能',
    path: '/pro',
    resource: 'pulsar:pro',
    id: 'pro',
    children: [
      {
        label: '消息轨迹',
        path: '/pro/message-trace',
        eventId: 'MESSAGE_TRACE_DETAIL',
        resource: 'pulsar:pro:messageTrace',
        id: 'pro/message-trace',
      },
    ],
  },
];

const appendParent = (menus, parent) => {
  menus.map((menu) => {
    if (parent) {
      const { children, ...others } = parent;
      menu.parent = others;
    }
    if (!isEmpty(menu.children)) {
      appendParent(menu.children, menu);
    }
  });
};

appendParent(menus);

export const fetchIsOrdinaryUserPrompt = createAsyncThunk(
  'layout/fetchIsOrdinaryUserPrompt',
  async () => {
    const response = await getIsOrdinaryUserPrompt();
    return response.data;
  },
);

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: {
    menus,
    clientWidth: document.body.clientWidth,
    clientHeight: document.body.clientHeight,
    currentModule: '/cluster', // 默认pulsar集群模块
    globalWarn: [], // 全局告警信息
  },
  reducers: {
    recordSize: (state, action) => {
      const { clientHeight, clientWidth } = action.payload;
      state.clientHeight = clientHeight;
      state.clientWidth = clientWidth;
    },
    // 生成授权后的菜单
    generateRoleMenu: (state, action) => {
      const { perms } = action.payload;
      const filterMenus = (menuArray) => {
        const authorizedMenu = [];
        for (const menu of menuArray) {
          if (perms.includes(menu.resource)) {
            const temp = { ...menu };
            if (temp.children) {
              temp.children = filterMenus(temp.children);
            }
            authorizedMenu.push(temp);
          }
        }
        return authorizedMenu;
      };

      const filtered = filterMenus(menus);
      state.menus = filtered || [];
    },
    doCacheClusterModule: (state, action) => {
      state.currentModule = action.payload;
    },
    cleanGlobalWarn: (state, action) => {
      const type = action.payload;
      state.globalWarn = state.globalWarn.filter((item) => item.type !== type);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIsOrdinaryUserPrompt.pending, (state) => {
        const { globalWarn } = state;
        state.globalWarn = globalWarn.filter(
          (item) => item.type !== messageTypes.HEADER_MESSAGE_IS_ORDINARY_USER,
        );
      })
      .addCase(fetchIsOrdinaryUserPrompt.fulfilled, (state, action) => {
        const { ordinaryUser, promptInfo } = action.payload;
        const { globalWarn } = state;
        if (ordinaryUser) {
          state.globalWarn = [
            ...globalWarn,
            { message: promptInfo, type: messageTypes.HEADER_MESSAGE_IS_ORDINARY_USER },
          ];
        }
      });
  },
});

export const { recordSize, generateRoleMenu, doCacheClusterModule, cleanGlobalWarn } =
  layoutSlice.actions;
export default layoutSlice.reducer;
